(() => {
  function init(root) {
    if (root.dataset.scReady) return;
    root.dataset.scReady = 'true';
    const grid = root.querySelector('[data-sc-grid]');
    const search = root.querySelector('[data-sc-search]');
    const sort = root.querySelector('[data-sc-sort]');
    const cards = [...grid.querySelectorAll('[data-sc-product]')];
    function update() {
      const query = search.value.trim().toLowerCase();
      let count = 0;
      const ordered = [...cards].sort((a,b) => sort.value === 'price-low' ? Number(a.dataset.price)-Number(b.dataset.price) : sort.value === 'price-high' ? Number(b.dataset.price)-Number(a.dataset.price) : sort.value === 'title' ? a.dataset.title.localeCompare(b.dataset.title) : Number(a.dataset.order)-Number(b.dataset.order));
      ordered.forEach(card => {card.hidden = !card.dataset.title.includes(query); if (!card.hidden) count++; grid.append(card);});
      root.querySelector('[data-sc-count]').textContent = `${count} ${count === 1 ? 'squishy' : 'squishies'} to explore`;
      root.querySelector('[data-sc-empty]').hidden = count > 0;
    }
    search.addEventListener('input', update);
    sort.addEventListener('change', update);
  }
  document.querySelectorAll('[data-sc-shop]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-sc-shop]').forEach(init));
})();
